import type { VoiceCallSession } from '../types/voice-call'

/**
 * A consent END that lands this soon after the call already ended another
 * way (Chime's MeetingEnded raced it) still re-classifies that end.
 */
export const CONSENT_RECLASSIFY_WINDOW_MS = 10_000

/** The live call just ended as something else — make it `consent-missing`. */
export function shouldReclassifyAsConsentEnd(
  live: Pick<VoiceCallSession, 'callId' | 'phase' | 'endReason' | 'endedAt'> | null | undefined,
  callId: string,
  now: number,
): boolean {
  return Boolean(
    live &&
      live.callId === callId &&
      live.phase === 'ended' &&
      live.endReason !== 'consent-missing' &&
      live.endedAt != null &&
      now - live.endedAt <= CONSENT_RECLASSIFY_WINDOW_MS,
  )
}

type Listener = (callId: string) => void
const listeners = new Set<Listener>()

/** The server's recording-consent window ended `callId` (even if it already ended locally). */
export function emitConsentWindowEnded(callId: string): void {
  for (const listener of listeners) listener(callId)
}

export function onConsentWindowEnded(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
